import { isAuthenticated } from '@/modules/user/helpers/guards';
import Checkout from './views/Checkout.vue';
import Cart from './views/Cart.vue';
import Offer from './views/Offer.vue';
import Success from './views/Success.vue';

const routes = [
  {
    path: '/checkout',
    name: 'Checkout',
    component: Checkout,
    beforeEnter: isAuthenticated,
    meta: { layout: 'simple' },
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart,
    beforeEnter: isAuthenticated,
    meta: { layout: 'simple' },
  },
  {
    path: '/offer',
    name: 'Offer',
    component: Offer,
    beforeEnter: isAuthenticated,
    meta: { layout: 'empty' },
  },
  {
    path: '/success',
    name: 'Success',
    component: Success,
    beforeEnter: isAuthenticated,
    meta: { layout: 'empty' },
  },
];

export default routes;
